const IconButton = (props) => {
    const { children, onClick } = props

    return (
        <button
            style={{ marginLeft: '10px' }}
            className="btn btn--animated btn--white"
            onClick={onClick}
        >
            {children}
        </button>
    )
}

export default IconButton